module.exports = __webpack_public_path__ + "static/cost-estimator-30a4b66a8cb70c0868a5b56451321c45.png";